export const filterFileName = (fileName) => {
  return fileName?.split("_").slice(1).join("_");
};

export const copyUrlToClipboard = (path, onSucces, onError) => {
  setTimeout(() => {
    navigator.clipboard
      .writeText(`${window.location.origin}${path}`)
      .then(() => {
        if (onSucces) onSucces();
      })
      .catch((e) => {
        if (onError) onError(e);
      });
  }, 0);
};

export const getInitials = (fullName) => {
  const initials = fullName.split(" ").map((name) => name[0]);
  return initials.join("").toUpperCase();
};
